
import { Link } from 'react-router-dom';
import PageHero from '../../../components/base/PageHero';

export default function AboutHeroSection() {
  return (
    <PageHero
      breadcrumb="About Us"
      label="Our Story"
      title={<>Building Excellence<br />Since 2007</>}
      description="From humble beginnings to becoming one of South Africa's leading QCTO-accredited training providers — driven by an unwavering commitment to transforming lives through quality education."
      bgImage="/about-hero.png"
    >
      <Link to="/contact"><button className="btn btn-white">Work With Us <i className="ri-arrow-right-line ml-2" /></button></Link>
      <Link to="/programmes"><button className="btn btn-ghost">View Programmes</button></Link>
    </PageHero>
  );
}
